// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_TournamentsCreationForm__OSJr9{
    background-color: white;
    display: grid;
    grid-template-columns: 6fr;
}

.styles_InputFields__sp8Uz {
    margin-top: 30px!important;
    margin-right: 10px!important;
    margin-left: 10px!important;
}
.styles_CountryCityRow__YNsRR{
    display: flex;
    justify-content: start;
}
.styles_CountryCityRow__YNsRR > * {
    width: 100px;
}
.styles_WeightHeightRow__M4cd0{
    display: flex;
    justify-content: space-between;
}
.styles_WeightHeightRow__M4cd0 > * {
    width: 300px;
}

.styles_SelectorWrapper__C4UuB{
    margin-top: 30px!important;
    margin-right: 10px!important;
    margin-left: 10px!important;
}

.styles_FieldRow__\\+9vR\\+{
    display: grid;
    grid-template-columns: 400px 220px 220px 170px 170px;
}

.styles_DateDivider__oFyfS{
    display: flex;
    justify-content: center;
    align-items: center;
}
.styles_Selectors__10o9A {
    display: grid;
    grid-template-columns: 170px 170px 170px 170px;
}
.styles_CountryISOWithWonTypeRow__9CcCI{
    display: grid;
    grid-template-columns: 220px 220px 220px;
}

@media (max-width: 768px) {
    .styles_TournamentsCreationForm__OSJr9 {
        width: 100vw;
        overflow: auto;
        display: flex;
        flex-direction: column;
    }
    .styles_FieldRow__\\+9vR\\+ {
        display: flex;
        flex-direction: column;
    }
    .styles_Selectors__10o9A {
        display: flex;
        flex-direction: column;
    }
    .styles_CountryISOWithWonTypeRow__9CcCI {
        display: flex;
        flex-direction: column;
    }
    .styles_WeightHeightRow__M4cd0 > * {
        width: 100%;
    }
    .styles_SelectorWrapper__C4UuB{
        >div {
            width: 100%;
        }
    }
}`, "",{"version":3,"sources":["webpack://./src/widgets/tournament/tournament-creation-form/styles.module.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,YAAY;AAChB;AACA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,8CAA8C;AAClD;AACA;IACI,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI;QACI,YAAY;QACZ,cAAc;QACd,aAAa;QACb,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;IACA;QACI;YACI,WAAW;QACf;IACJ;AACJ","sourcesContent":[".TournamentsCreationForm{\n    background-color: white;\n    display: grid;\n    grid-template-columns: 6fr;\n}\n\n.InputFields {\n    margin-top: 30px!important;\n    margin-right: 10px!important;\n    margin-left: 10px!important;\n}\n.CountryCityRow{\n    display: flex;\n    justify-content: start;\n}\n.CountryCityRow > * {\n    width: 100px;\n}\n.WeightHeightRow{\n    display: flex;\n    justify-content: space-between;\n}\n.WeightHeightRow > * {\n    width: 300px;\n}\n\n.SelectorWrapper{\n    margin-top: 30px!important;\n    margin-right: 10px!important;\n    margin-left: 10px!important;\n}\n\n.FieldRow{\n    display: grid;\n    grid-template-columns: 400px 220px 220px 170px 170px;\n}\n\n.DateDivider{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.Selectors {\n    display: grid;\n    grid-template-columns: 170px 170px 170px 170px;\n}\n.CountryISOWithWonTypeRow{\n    display: grid;\n    grid-template-columns: 220px 220px 220px;\n}\n\n@media (max-width: 768px) {\n    .TournamentsCreationForm {\n        width: 100vw;\n        overflow: auto;\n        display: flex;\n        flex-direction: column;\n    }\n    .FieldRow {\n        display: flex;\n        flex-direction: column;\n    }\n    .Selectors {\n        display: flex;\n        flex-direction: column;\n    }\n    .CountryISOWithWonTypeRow {\n        display: flex;\n        flex-direction: column;\n    }\n    .WeightHeightRow > * {\n        width: 100%;\n    }\n    .SelectorWrapper{\n        >div {\n            width: 100%;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TournamentsCreationForm": `styles_TournamentsCreationForm__OSJr9`,
	"InputFields": `styles_InputFields__sp8Uz`,
	"CountryCityRow": `styles_CountryCityRow__YNsRR`,
	"WeightHeightRow": `styles_WeightHeightRow__M4cd0`,
	"SelectorWrapper": `styles_SelectorWrapper__C4UuB`,
	"FieldRow": `styles_FieldRow__+9vR+`,
	"DateDivider": `styles_DateDivider__oFyfS`,
	"Selectors": `styles_Selectors__10o9A`,
	"CountryISOWithWonTypeRow": `styles_CountryISOWithWonTypeRow__9CcCI`
};
export default ___CSS_LOADER_EXPORT___;
